const firebaseConfig = {
    apiKey: "AIzaSyBamMqBbFbnRQI_d2nsjlYFyEn-yS46gS8",
    authDomain: "sunglass-shop-299fb.firebaseapp.com",
    projectId: "sunglass-shop-299fb",
    storageBucket: "sunglass-shop-299fb.appspot.com",
    messagingSenderId: "943509335528",
    appId: "1:943509335528:web:3bb9018c33a7059841c85d"
};
export default firebaseConfig;